export default function (cb) {
  if ('complete' === document.readyState) {
    cb();
  }

  document.addEventListener('DOMContentLoaded', cb);
}



// WEBPACK FOOTER //
// ./client/src/js/utils/domContentLoaded.js